import { Injectable } from '@angular/core';
import { ObjectCacheService } from './icache-service';
import { ParamMap } from '../data-service/system-param-cache-define';
import { ParameterApi } from '../api-service/parameters/parameter-api';
import { EasyNotificationService } from '../easy-notification.service';
import { GpParaApi } from '../api-service/gp-para/gp-para-api';
import { NhiimiSetting } from 'src/app/system/clinic/models/nhiimiSetting';
import { ClinicApi } from '../api-service/clinic/clinic-api';
import { UserCache } from '../user-cache';
import { SpecialSameTreatDto, SpecialSameTreatRxDto } from '../api-service/val-addapp/special-sameTreat-dto';
import { TemporaryWorkApi } from '../api-service/val-addapp/temporaryWork-api';
import { PricingApi } from '../api-service/pricing/pricing-api';
import { PaymentApi } from '../api-service/payment/payment-api';
import { DiscountPriorityApi } from '../api-service/payment/discount-priority-api';
import { DiscountPriorityDto } from '../api-service/register/discount-priority-dto';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';

@Injectable({
  providedIn: 'root'
})

/**
 * 系統參數快取Service。
 * @implements {ICacheService<ParamType, Map<ParamType, any>>}
 */
export class DiscountCachedService extends ObjectCacheService<DiscountObject> {

  protected notifyMsgOnUpdated: string = '暫存內容已變更…';
  protected notifyMsgOnReload: string = '已重載暫存內容'
  /**
   * 建構子，初始化服務。
   * @param {ParameterApi} parameterApi - 用於獲取參數的 API 服務。
   * @param {EasyNotificationService} notifyService - 用於顯示通知的服務。
   */
  constructor( 
    private dicsountApi:DiscountPriorityApi,
    private notifyService: EasyNotificationService) {
    super(notifyService);
  }

  protected async getCacheObject<k extends string|number>(keys: k[]): Promise<Map<k, ValueTextPair[]>> {
    var m:Map<k, ValueTextPair[]> = new Map();
    for(let d of keys){
      var ret = await this.dicsountApi.GetDiscountByDate(new Date(d)) 
      m.set(d,ret);
    }
    return m;
  }
}
declare type DiscountObject = {[key:string]:ValueTextPair[]}
